import React from 'react';

const AudioContext = window.AudioContext || window.webkitAudioContext;
export default function useAudioContext() {
    const [stream, setStream] = React.useState();
    const [audioContext, setAudioContext] = React.useState();
    React.useEffect(() => {
        (async () => {
            const stream = await navigator.mediaDevices.getUserMedia({
                audio: {
                    mandatory: {
                        googEchoCancellation: 'true',
                        googAutoGainControl: 'true',
                        googNoiseSuppression: 'true',
                        googHighpassFilter: 'true',
                    },
                    optional: [],
                },
            });
            console.log('stream', stream);

            setAudioContext(new AudioContext());
            setStream(stream);
        })();
    }, []);

    return { stream, audioContext };
}
